module.exports = __webpack_public_path__ + "media/images/icons/print-aa43bdc0531a26a24dbf2080a176f2f7.svg";